import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource-variable/jetbrains-mono';
import './styles/index.css';
import { App } from './app/App';
import { OverlayProvider } from './overlay';
import { installNativeDialogGuard } from './overlay/nativeDialogGuard';

// 禁止浏览器原生弹窗：统一走 overlay 的确认/提示弹窗，
// 否则在开发环境下会静默返回 false，行为难以排查。
installNativeDialogGuard();

const container = document.getElementById('root');
if (!container) {
  throw new Error('找不到 #root 挂载点，检查 index.html 是否被改动');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <OverlayProvider>
        <App />
      </OverlayProvider>
    </BrowserRouter>
  </StrictMode>,
);
